module.exports = __webpack_public_path__ + "img/fish2.aea99240.png";